import { signal } from 'services/SignalsService'

const name = 'CASCADE-WIN'

async function execute() {
  const cascadeModel = game.models.CascadeModel.get()
  const amount = cascadeModel.wins[cascadeModel.currentCascade].total
  if(cascadeModel.wins[cascadeModel.currentCascade]){
    signal.dispatch('CASCADE-WIN-UPDATE-COUNTER', { type: 'regular', amount })
    signal.dispatch('CURRENT-CASCADE', cascadeModel.currentCascade)
    return signal.promise('CASCADE-WIN-ANIM:DONE')
  }
}

export function getCascadeWinAction() {
  return {
    name,
    execute,
  }
}
